import { useMemo } from 'react';
import { AnimatePresence, motion } from 'framer-motion';

import { useGetParams } from './hooks/useGetParams';
import { useBroadcast } from './hooks/useBroadcast';

import { Advt } from './components/Advt/Advt';
import Message from './components/Message/Message';
import { Winners } from './components/Winners/Winners';

import defaultBackground from './assets/images/bgPoster.png';

function App() {
  const { isVisible, currentState, currentMessage, winnerMessages } =
    useBroadcast();
  const { speedSlow, bg } = useGetParams();

  const background = useMemo(() => {
    return bg && bg !== '0'
      ? `url(${bg === '1' ? defaultBackground : bg}) center/cover no-repeat`
      : `none`;
  }, [bg]);

  return (
    <div
      className="app-wrapper"
      style={{
        background,
        '--speed': `${speedSlow || 2000}ms`,
        '--speedExit': `${(speedSlow || 2000) / 1.5}ms`,
      }}
    >
      <div className="messagesWrapper">
        <AnimatePresence mode="wait">
          {currentState === 'S2' && currentMessage && (
            <motion.div
              key="message-s2"
              exit={{ opacity: 0 }}
              transition={{ duration: 0.5 }}
            >
              <Message
                message={currentMessage?.message}
                rotateSign={currentMessage?.rotateSign}
                speedSlow={speedSlow}
              />
            </motion.div>
          )}
        </AnimatePresence>
      </div>

      <AnimatePresence mode="wait">
        {['S1', 'S2'].includes(currentState) && (
          <motion.div
            key="advt"
            className="advtWrapper"
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
          >
            <Advt currentState={currentState} />
          </motion.div>
        )}
      </AnimatePresence>

      <AnimatePresence mode="wait">
        {currentState === 'S3' && (
          <motion.div
            key={currentState}
            className="winnersBlock"
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
          >
            <Winners winnerMessages={winnerMessages} />
          </motion.div>
        )}
      </AnimatePresence>

      <div id="img-loader"></div>
    </div>
  );
}

export default App;
